import React, { useEffect, useRef, useState } from 'react'
import styles from './EditableVideo.module.sass'

interface Props {
  iframeId?: string
  item?: any
  preserveRatio?: boolean
  playControl?: boolean
  editMode?: boolean
  className?: string
  style?: any
}

export const videoProviders = {
  local: null,
  youtube: {
    url: 'https://www.youtube.com/embed/',
  },
  youtube_nocookie: {
    url: 'https://www.youtube-nocookie.com/embed/',
  },
  vimeo: {
    url: 'https://player.vimeo.com/video/',
  },
}

const EditableVideo = (props: Props) => {
  const {
    iframeId = undefined,
    item = undefined,
    preserveRatio = false,
    playControl = undefined,
    editMode = false,
    className = '',
    style = undefined,
  } = props

  const videoRef = useRef(null)

  useEffect(() => {
    if (playControl && videoRef?.current) videoRef.current.play()
  }, [playControl])

  const getIframeSrc = () => {
    if (item?.provider && videoProviders[item.provider]) {
      let url = videoProviders[item.provider].url + item.videoId + '?enablejsapi=1'
      if (item.autoplay && typeof playControl === 'undefined') {
        // se uso playControl non dev'essere in autoplay
        url += '&autoplay=1'
      }
      if (item.muted) {
        url += '&mute=1'
      }
      if (item.loop) {
        url += `&loop=1&playlist=${item.videoId}`
      }
      if (item.provider !== 'vimeo') {
        if (!item.controls) {
          url += '&controls=0&showinfo=0'
        }
        if (!item.related) {
          url += '&rel=0'
        }
        if (!item.disablekb) {
          url += '&disablekb=1'
        }
      }

      return url
    }
    return null
  }

  return item?.provider !== 'local' ? (
    <div
      className={`${styles.root} ${styles['root--iframe']} ${
        item.ratio && preserveRatio ? styles[`root--${item.ratio.replace(':', '-')}`] : ''
      } ${className}`}
    >
      <iframe
        id={iframeId}
        src={getIframeSrc()}
        allowFullScreen
        allow={editMode ? '' : 'autoplay'}
        style={{
          ...(style || {}),
          pointerEvents: editMode ? 'none' : undefined,
        }}
        className={styles.iframe}
        aria-hidden={item.ariaHidden || undefined}
      />
    </div>
  ) : item?.url ? (
    <video
      controls={item.controls}
      autoPlay={item.autoplay}
      playsInline
      muted={item.autoplay ? true : item.muted}
      loop={item.loop}
      className={`${styles.embed} ${className}`}
      aria-hidden={item.ariaHidden || undefined}
      style={style}
      ref={videoRef}
    >
      <source src={item.url} type="video/mp4" />
    </video>
  ) : editMode ? (
    <div className={`${styles.root} ${styles['root--editMode']} ${styles['root--empty']}`}></div>
  ) : (
    <></>
  )
}

export default EditableVideo
